import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MydiaryService } from 'src/app/services/mydiary.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { OrganizationSetupCommon } from '../organization-setup.common';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { ComponentCanDeactivate } from 'src/app/guard/component.can-deactivate.guard';
import Swal from 'sweetalert2';
import { CommonMessageService } from '../../services/common-message.service';

@Component({
  selector: 'app-manpower-budget',
  templateUrl: './manpower-budget.component.html',
  styleUrls: ['./manpower-budget.component.css'],
})
export class ManpowerBudgetComponent implements OnInit, ComponentCanDeactivate {
  budgetForm: any;
  financialYearList: any;
  branchList: any;
  assignedPartnerList: any;
  clientList: any;
  assignmentList: any;
  roleList: any;
  serviceVerticalList: any;
  employeeList: any;

  formStatus = 'add';
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.budgetFormErrors;
  formValidationMessages = OrganizationSetupCommon.budgetFormValidationMessages;

  routeParam: any;
  redirectFromClient = false;

  onAssignmentSelectBudgetDays;

  constructor(
    private OrganizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private mydiaryService: MydiaryService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonMessageService: CommonMessageService
  ) {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      console.log(params.fyId);
      if (params.clientId && params.branchId) {
        this.redirectFromClient = true;
        this.routeParam = params;
        console.log(this.routeParam);
      } else {
        this.redirectFromClient = false;
        this.routeParam = null;
      }
    });
  }

  ngOnInit(): void {
    this.initModalForm();
    this.budgetForm.get('role')?.valueChanges.subscribe((role) => {
      console.log('role change', role);
      this.onRoleChange(role);
    });
  }

  confirm() {
    return !this.budgetForm.submitted && this.budgetForm.dirty ? true : false;
  }

  initModalForm() {
    this.budgetForm = this.fb.group({
      id: [''],
      assignedPartner: [null, [Validators.required]],
      assignment: [null, [Validators.required]],
      assignmentFees: ['', [Validators.required]],
      branch: [null, [Validators.required]],
      budgetDetails: this.fb.array([]),
      client: [null, [Validators.required]],
      financialYear: [null, [Validators.required]],
      role: [null],
      serviceVertical: [null],
      employee: [null],
    });
    this.loadFinancialYear();
  }
  //-----------------------
  loadFinancialYear() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      console.log(res);
      this.financialYearList = res;
      if (this.redirectFromClient) {
        // var max = this.financialYearList.reduce(function(prev, current) {
        //   if (+current.id > +prev.id) {
        //       return current;
        //   } else {
        //       return prev;
        //   }
        // });
        var fyIndex = -1;
        this.financialYearList.forEach((element, key) => {
          var startDate = new Date(element.startDate);
          var endDate = new Date(element.endDate);
          // var currentDate = new Date();
          var currentDate = moment(new Date()).format('YYYY-MM-DD');
          console.log(startDate, endDate);
          console.log(currentDate);
          if (
            currentDate >= element.startDate &&
            currentDate <= element.endDate
          ) {
            fyIndex = key;
          }
        });

        this.budgetForm.patchValue({
          financialYear: this.financialYearList[fyIndex],
        });
      }

      this.loadBranch();
    });
  }

  loadBranch() {
    this.masterDataService.getBranch().subscribe((res) => {
      console.log(res);
      this.branchList = res;
      if (this.redirectFromClient) {
        const branchIndex = this.branchList.findIndex(
          (item) => item.id == parseInt(this.routeParam.branchId)
        );
        this.budgetForm.patchValue({
          branch: this.branchList[branchIndex],
        });
        this.loadAssignedPartnerForBranch(this.budgetForm.value.branch);
      }
      this.loadRoles();
      this.loadServiceVerticals();
    });
  }

  loadRoles() {
    this.masterDataService.getRoles().subscribe((res) => {
      console.log(res);
      this.roleList = res;
    });
  }

  loadServiceVerticals() {
    this.masterDataService.getServiceVerticalList()
      .subscribe(res => {
        this.serviceVerticalList = res;
      })
  }

  compareById = (o1: any, o2: any): boolean => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };

  onRoleChange(role: any) {
    const serviceVerticalControl = this.budgetForm.get('serviceVertical');

    if (role?.name === 'Article') {
      serviceVerticalControl?.disable();
      serviceVerticalControl?.reset(null);
      this.loadEmployeesForServiceVerticalAndRoles();
    } else {
      serviceVerticalControl?.enable();
      serviceVerticalControl?.reset(null);
    }
  }

   loadEmployeesForServiceVerticalAndRoles() {
      console.log('LoadEmployee', role)
      var role = this.budgetForm.controls.role.value;
      var serviceVertical = this.budgetForm.controls.serviceVertical.value;
      var branch = this.budgetForm.controls.branch.value;
      console.log('role', role)
      console.log('branch', branch)
      console.log('serviceVertical', serviceVertical)
      if (role != "null") {
        if (role.id == 1 && role.name == 'Article') {
          if (this.assignedPartnerList.length == 0) {
            this.loadAssignedPartnerForBranch(this.budgetForm.value.branch);
          }
          console.log('assignedPartnerList', this.assignedPartnerList);
          this.employeeList = this.assignedPartnerList;
          this.budgetForm.get('serviceVertical').clearValidators();
          this.budgetForm.get('serviceVertical').updateValueAndValidity();
        } else {
          // this.OrganizationSetupService.getEmployeesForServiceVerticalAndRoles(branch.id, serviceVertical.id, role.id).subscribe(
          this.OrganizationSetupService.getEmployeesForServiceVerticalAndRoles(serviceVertical.id, role.id).subscribe(  
          (res) => {
              console.log('employee list', res);
              this.employeeList = res;
            }
          );
        }
      } else {
  
        this.commonMessageService.swalAlertWithoutIcon('', "Please Select Role")
      }
    }
  //-------------------------------------
  resetBudgetForm() {
    this.formStatus = 'add';
    this.formSubmitted = false;
    this.budgetForm.controls['budgetDetails'].clear();
    this.budgetForm.reset();
  }

  addBudgetBtnClick() {
    // this.loadStandardRate();
    this.loadStandardRateByServiceVertical();
  }

  // loadStandardRate() {
  //   this.OrganizationSetupService.getStandardRate(
  //     this.budgetForm.value.financialYear.id,
  //     this.budgetForm.value.branch.id,
  //     this.budgetForm.value.role.id
  //   ).subscribe((resp) => {
  //     console.log('standard rate: ', resp);
  //     this.loadUserDetails(resp);
  //   });
  // }

  loadStandardRateByServiceVertical() {
      if (this.budgetForm.value.serviceVertical == null || this.budgetForm.value.serviceVertical == 'undefined') {
        this.OrganizationSetupService.getStandardRate(
          this.budgetForm.value.financialYear.id,
          this.budgetForm.value.branch.id,
          this.budgetForm.value.role.id
        ).subscribe((resp) => {
          console.log('standard rate: ', resp);
          this.loadUserDetails(resp);
        });
      } else {
        this.OrganizationSetupService.getStandardRateByServiceVertical(
          this.budgetForm.value.financialYear.id,
          this.budgetForm.value.branch.id,
          this.budgetForm.value.serviceVertical?.id ?? null,
          this.budgetForm.value.role.id
        ).subscribe((resp) => {
          console.log('standard rate: ', resp);
          this.loadUserDetails(resp);
        });
      }
    }
  

  loadUserDetails(standardRate) {
    this.humanResourceService
      .viewProfile(this.budgetForm.get('employee').value.userId)
      .subscribe((resp) => {
        console.log('View profile: ', resp);
        this.addBudget(standardRate, resp);
        this.isExistBudgetCheck = true;
      });
  }

  isExistBudgetCheck: boolean;
  isNewBudgetCheck: boolean;
  setAssignmentValue;
  addBudget(standardRate, userDetails) {
    console.log('this.budgetForm.value.assignment.id;', this.budgetForm.value.assignment);
    console.log('budget details', this.budgetForm.get('budgetDetails'));
    this.setAssignmentValue = this.budgetForm.value.assignment;
    const budget_details = (<FormArray>this.budgetForm.get('budgetDetails'))
      .value;

    if (budget_details && budget_details.length > 0) {
      const found_match = budget_details.find(
        (el) => el.user.userId === userDetails.userId
      );

      if (
        found_match?.role?.id &&
        found_match.role.id === standardRate.role.id
      ) {
        console.log('Found match: ', found_match);
         this.commonMessageService.swalAlertWithoutIcon('','Already in this list.');
      } else {
        console.log('Not found: ', found_match);

        (<FormArray>this.budgetForm.get('budgetDetails')).push(
          this.initBudgetDetails(standardRate, userDetails)
        );
      }
    } else {
      console.log('Budget details here: ', budget_details);
      (<FormArray>this.budgetForm.get('budgetDetails')).push(
        this.initBudgetDetails(standardRate, userDetails)
      );
    }
    console.log(this.budgetForm);
  }

  initBudgetDetails(standardRate, userDetails) {
    return this.fb.group({
      id: [''],
      role: [this.budgetForm.get('role').value],
      serviceVertical: [this.budgetForm.get('serviceVertical').value],
      user: [userDetails],
      standardRate: [standardRate.rate, Validators.required],
      budgetedDays: [0, Validators.required],
      count: [1, Validators.required],
      // fromDate: [null, Validators.required],
      // toDate: [null, Validators.required],
    });
  }

  removeBudget(index: number): void {
    console.log('remove budget', index);
    if (confirm('Are you sure you want to delete?')) {
      const formArray = <FormArray>this.budgetForm.get('budgetDetails');
      console.log('formarray', formArray);

      formArray.removeAt(index);

      console.log('After remove', formArray);
      formArray.markAsDirty();
      formArray.markAsTouched();
       this.commonMessageService.swalAlertWithoutIcon('','Click on update for Deleted Successfully!');
    }
  }
  //-------------------------------------
  onChangeFinancialYear() {
    console.log('inside year method');
    this.budgetForm.patchValue({
      assignedPartner: null,
      assignment: null,
      assignmentFees: '',
      branch: null,
      client: null,
      role: null,
      serviceVertical: null,
      employee: null,
    });
    this.budgetForm.controls['budgetDetails'].clear();
  }

  loadAssignedPartnerForBranch(branch) {
    // this.onChangeFinancialYear();
    // this.resetOnBranchChange();
    if (branch != "null") {
      this.OrganizationSetupService.getPartnerListForBranch(branch.id).subscribe(
        (res) => {
          console.log('res', res);
          this.assignedPartnerList = res;
        }
      );
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"Please select Branch");
    }
  }

  loadClientsForPartner(partner) {
    if (partner != "null") {
      this.OrganizationSetupService.getClientListForPartner(partner.id).subscribe(
        (res) => {
          console.log(res);
          this.clientList = res;
          if (this.redirectFromClient) {
            console.log('redirectFromClient');
            const clientIndex = this.clientList.findIndex(
              (item) => item.id == parseInt(this.routeParam.clientId)
            );
            this.budgetForm.patchValue({
              client: this.clientList[clientIndex],
            });
            if (this.budgetForm.value.client) {
              this.loadClientAssignment(
                this.budgetForm.value.client,
                this.budgetForm.value.assignedPartner,
                this.budgetForm.value.financialYear
              );
            }
          }
        }
      );
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"Please Select Partner");
    }
  }

  loadClientAssignment(client, partner, year) {
    this.isExistBudgetCheck = false;
    this.isNewBudgetCheck = false;
    if (client != "null" && partner != "null" && year != "null") {
      this.mydiaryService
        .getClientAssignments(client.id, partner.id, year.id)
        .subscribe((res) => {
          console.log(res);
          this.assignmentList = res;
          this.budgetForm.patchValue({
            assignment: null,
            assignmentFees: '',
            role: null,
            employee: null,
          });
          this.budgetForm.controls['budgetDetails'].clear();
        });
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"Please select Client");
    }
  }

  loadEmployeesForRoles(role) {
    console.log('LoadEmployee', role)
    if (role != "null") {
      if (role.id == 1 && role.name == 'Article') {
        this.employeeList = this.assignedPartnerList;
      } else {
        this.OrganizationSetupService.getEmployeesForRoles(role.id).subscribe(
          (res) => {
            console.log('employee list', res);
            this.employeeList = res;
          }
        );
      }
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"Please Select Role")
    }
  }

  // Check if budget Exist
  budgetExist: any;
  checkAssignmentChange: boolean;
  checkIfBudgetExist() {
    console.log('this.budgetForm.value.assignment.id;', this.budgetForm.value.assignment);
    console.log('budgetdetails', this.budgetForm.controls['budgetDetails'].value.role);
    console.log('budgetform', this.budgetForm.value);
    console.log('bolean values', this.isExistBudgetCheck, this.isNewBudgetCheck);
    if (this.isExistBudgetCheck && this.isNewBudgetCheck == false) {
      this.checkAssignmentChange = true;
      console.log('updated budget response', this.isNewBudgetCheck, this.isExistBudgetCheck);
      if (this.budgetForm.value.budgetDetails.length >= 1) {
        this.OrganizationSetupService.updateBudget(
          this.getValueFromModal(),
          this.budgetForm.value.id
        ).subscribe((resp) => {
          // console.log('updated budget response', resp);
          this.showDetailsOfBudget();
        });
      } else {
         this.commonMessageService.swalAlertWithoutIcon('',"please create budget for this " + this.budgetForm.value.assignment.name + " assigment")
      }
    } else if (this.isNewBudgetCheck && this.isExistBudgetCheck) {
      console.log('save budget response', this.isNewBudgetCheck, this.isExistBudgetCheck);

      var r = confirm('Are you sure you want to save budget.');
      if (r == true) {
        this.checkAssignmentChange = true;
        this.budgetForm.value.id = '';
        if (this.budgetForm.value.budgetDetails.length >= 1) {
          this.OrganizationSetupService.saveBudget(
            this.getValueFromModal()
          ).subscribe((resp) => {
            // this.commonMessageService.saveMessage();
             this.commonMessageService.swalAlertWithoutIcon('','Saved Successfully.');
            this.showDetailsOfBudget();
          });
        } else {
           this.commonMessageService.swalAlertWithoutIcon('',"Please create budget for this " + this.budgetForm.value.assignment.name + " assigment")
        }
      } else {
        this.isExistBudgetCheck = false;
        this.isNewBudgetCheck = false;
        this.showDetailsOfBudget();
      }
    } else {
      console.log('inside else only show');
      this.showDetailsOfBudget();
    }
  }

  showDetailsOfBudget() {
    console.log('after update show details', this.budgetForm.value.assignment);
    var yearId = this.budgetForm.value.financialYear.id,
      branchId = this.budgetForm.value.branch.id,
      partnerId = this.budgetForm.value.assignedPartner.id,
      clientId = this.budgetForm.value.client.id,
      assignmentId = this.budgetForm.value.assignment.id;
    console.log('Assignment id value', yearId, branchId, partnerId, clientId, assignmentId);

    if (yearId != undefined && branchId != undefined && partnerId != undefined && clientId != undefined && assignmentId != undefined) {
      this.OrganizationSetupService.getExistingBudget(
        yearId,
        branchId,
        partnerId,
        clientId,
        assignmentId
      ).subscribe((res: any) => {
        console.log('exist budget details', res);
        this.budgetForm.controls['budgetDetails'].clear();
        if (res.budgetDetails.length > 0) {
          this.budgetExist = res;

          this.onAssignmentSelectBudgetDays = res;

          console.log('exist budget details', this.budgetExist);
          this.budgetExist.budgetDetails.map((res: any) => {
            console.log('budgeted days', res.budgetedDays);
          });
          this.formStatus = 'edit';
          this.setValueToModalForm(res);
          this.isExistBudgetCheck = false;
          this.isNewBudgetCheck = false;
        }
      }, (err) => {
        console.log('inside error', this.budgetForm.controls['budgetDetails']);
        this.budgetForm.controls['budgetDetails'].clear();
        this.budgetForm.patchValue({
          assignmentFees: undefined,
          role: null,
          serviceVertical: null,
          employee: null,
        });
        this.formStatus = 'add';
        this.isExistBudgetCheck = false;
        this.isNewBudgetCheck = true;
        console.log('inside error isNewBudgetCheck', this.isNewBudgetCheck);

      });
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"Please Select Assignment");
    }
  }

  setValueToModalForm(modalObj) {
    console.log('inside set value', modalObj);
    this.budgetForm.patchValue({
      id: modalObj.id,
      assignmentFees: modalObj.assignmentFees,
      // role: modalObj.budgetDetails[modalObj.budgetDetails.length - 1].role,
    });
    // this.loadEmployeesForRoles(this.budgetForm.value.role);
    // this.budgetForm.patchValue({ employee: modalObj.budgetDetails[modalObj.budgetDetails.length - 1].user });

    this.budgetForm.controls['budgetDetails'].clear();
    modalObj.budgetDetails.forEach((element, key) => {
      this.addBudgetDetailFormGroupInEdit(element);
    });
  }

  addBudgetDetailFormGroupInEdit(budgetDetail) {
    // var fromDate1 = new Date(budgetDetail.fromDate);
    // var fromDate2 = moment(fromDate1, 'YYYY/MM/DD');
    // var fromDate = {year:parseInt(fromDate2.format('YYYY')),month:parseInt(fromDate2.format('M')),day:parseInt(fromDate2.format('D'))};
    // var toDate1 = new Date(budgetDetail.toDate);
    // var toDate2 = moment(toDate1, 'YYYY/MM/DD');
    // var toDate = {year:parseInt(toDate2.format('YYYY')),month:parseInt(toDate2.format('M')),day:parseInt(toDate2.format('D'))};

    let formGroup = this.fb.group({
      id: [budgetDetail.id],
      role: [budgetDetail.role],
      serviceVertical: [budgetDetail.serviceVertical],
      user: [budgetDetail.user],
      standardRate: [budgetDetail.standardRate, Validators.required],
      budgetedDays: [budgetDetail.budgetedDays, Validators.required],
      count: [budgetDetail.count, Validators.required],
      // fromDate: [fromDate, Validators.required],
      // toDate: [toDate, Validators.required],
    });

    (<FormArray>this.budgetForm.get('budgetDetails')).push(formGroup);
  }

  // Get Total Cost
  getTotalCost() {
    var cost = 0;
    this.budgetForm.value.budgetDetails.forEach((element) => {
      cost = cost + element.standardRate * element.count * element.budgetedDays;
    });
    return cost;
  }

  // Reset on dropdown changes
  resetOnBranchChange() {
    console.log('resetOnBranchChange');
    this.budgetForm.patchValue({
      id: '',
      assignedPartner: null,
      assignment: null,
      assignmentFees: '',
      client: null,
      role: null,
      serviceVertical: null,
      employee: null,
    });
    this.budgetForm.controls['budgetDetails'].clear();
  }

  //

  // onDateChangedInBudgetDetail(index){
  //   var arrayControl = this.budgetForm.get('budgetDetails') as FormArray;
  //   var item = arrayControl.at(index) as FormGroup;
  //   var fromDate = new Date(item.value.fromDate.year + '-' + item.value.fromDate.month + '-' + item.value.fromDate.day );
  //   var toDate = new Date( item.value.toDate.year + '-' + item.value.toDate.month + '-' + item.value.toDate.day);
  //   var start = moment(fromDate, "YYYY-MM-DD");
  //   var end = moment(toDate, "YYYY-MM-DD");
  //   //Difference in number of days
  //   var days = moment.duration(start.diff(end)).asDays();
  //   item.controls['budgetedDays'].setValue(days)
  //   // this.formObj.controls['isSign'].setValue(true);
  // }

  // checkDateRangeOverlaps(dateObj1, dateObj2) {
  //   var isValid = true;
  //   var obj1FromDate = new Date(
  //     dateObj1.fromDate.year +
  //       '-' +
  //       dateObj1.fromDate.month +
  //       '-' +
  //       dateObj1.fromDate.day
  //   );
  //   var obj1ToDate = new Date(
  //     dateObj1.toDate.year +
  //       '-' +
  //       dateObj1.toDate.month +
  //       '-' +
  //       dateObj1.toDate.day
  //   );
  //   var obj2FromDate = new Date(
  //     dateObj2.fromDate.year +
  //       '-' +
  //       dateObj2.fromDate.month +
  //       '-' +
  //       dateObj2.fromDate.day
  //   );
  //   var obj2ToDate = new Date(
  //     dateObj2.toDate.year +
  //       '-' +
  //       dateObj2.toDate.month +
  //       '-' +
  //       dateObj2.toDate.day
  //   );
  //   if (obj2FromDate > obj1ToDate || obj2ToDate < obj1FromDate) {
  //   } else {
  //     isValid = false;
  //   }

  //   return isValid;
  // }

  // invalidBudgetDetailsKeyList:any;
  // multipleDateRangeOverlaps(){
  //   this.invalidBudgetDetailsKeyList=[];
  //   var arrayControl = this.budgetForm.get('budgetDetails') as FormArray;
  //   this.budgetForm.value.budgetDetails.forEach((element, key) => {
  //     var item1 = arrayControl.at(key) as FormGroup;
  //     var item2 = arrayControl.at(key + 1) as FormGroup;
  //     var isDurationValid = this.checkDateRangeOverlaps(
  //       item1.value,
  //       item2.value
  //     );
  //     if (!isDurationValid) {
  //       this.invalidBudgetDetailsKeyList.push(key);
  //       this.invalidBudgetDetailsKeyList.push(key + 1);
  //     }
  //   })
  //   if(this.invalidBudgetDetailsKeyList.length>0){
  //     this.invalidBudgetDetailsKeyList.forEach((element, key) => {
  //       var item = arrayControl.at(element) as FormGroup;
  //       // console.log(item);
  //       item.controls['fromDate'].setErrors({ incorrect: true });
  //       item.controls['toDate'].setErrors({ incorrect: true });
  //     });
  //   }else{
  //     this.budgetForm.value.budgetDetails.forEach((element, key) => {
  //       var item = arrayControl.at(key) as FormGroup;
  //       item.controls['fromDate'].setErrors({ incorrect: null });
  //       item.controls['toDate'].setErrors({ incorrect: null });
  //       item.controls['fromDate'].updateValueAndValidity();
  //       item.controls['toDate'].updateValueAndValidity();
  //     });
  //   }
  // }

  cancel() {
    this.resetBudgetForm();
  }

  onSaveClick() {
    console.log('inside save');
    console.log('on save click', this.budgetForm.value);
    this.formSubmitted = true;
    this.checkAssignmentChange = false;
    this.budgetForm.value.id = '';
    this.logValidationErrors(this.budgetForm);
    if (this.budgetForm.valid) {
      if (this.budgetForm.value.budgetDetails.length >= 1) {
        this.OrganizationSetupService.saveBudget(
          this.getValueFromModal()
        ).subscribe((resp) => {
          console.log(resp);
          this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
          this.resetBudgetForm();
          this.isExistBudgetCheck = false;
          this.isNewBudgetCheck = false;
        });
      } else {
         this.commonMessageService.swalAlertWithoutIcon('',"Please create budget for this " + this.budgetForm.value.assignment.name + " assigment")
      }
    }
  }

  onUpdateClick() {
    console.log('budgetform value isExistBudgetCheck', this.budgetForm.value);
    console.log('Assignment id value', this.budgetForm.value.assignment.id);
    this.formSubmitted = true;
    this.checkAssignmentChange = false;
    this.logValidationErrors(this.budgetForm);
    if (this.budgetForm.valid) {
      if (this.budgetForm.value.budgetDetails.length >= 1) {
        console.log("give api call")
        this.OrganizationSetupService.updateBudget(
          this.getValueFromModal(),
          this.budgetForm.value.id
        ).subscribe((resp) => {
          console.log('updated budget response', resp);
          this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success')
          this.resetBudgetForm();
          this.isExistBudgetCheck = false;
          this.isNewBudgetCheck = false;
        });
      } else {
        this.commonMessageService.swalAlertWithoutIcon('',"Please create budget for this " + this.budgetForm.value.assignment.name + " assigment")
      }

    }
  }

  getValueFromModal() {
    let data: any;
    data = { ...this.budgetForm.value };
    if (this.checkAssignmentChange) {
      console.log('inside checkAssignmentChange', this.checkAssignmentChange);
      data.assignment = this.setAssignmentValue;
    }
    data.budgetDetails = [];
    this.budgetForm.value.budgetDetails.forEach((element, key) => {
      // var fromDate = new Date(
      //   element.fromDate.year + '-' + element.fromDate.month + '-' + element.fromDate.day
      // );
      // var toDate = new Date(
      //   element.toDate.year + '-' + element.toDate.month + '-' + element.toDate.day
      // );
      const budgetDetail = {
        id: element.id,
        role: element.role,
        serviceVertical: element.serviceVertical,
        user: { id: element.user.id },
        standardRate: element.standardRate,
        budgetedDays: element.budgetedDays,
        count: element.count,
        // fromDate: moment(fromDate).format('YYYY-MM-DD'),
        // toDate:  moment(toDate).format('YYYY-MM-DD'),
      };
      data.budgetDetails.push(budgetDetail);
    });
    var jsonData = JSON.stringify(data);
    console.log('data', jsonData);
    return jsonData;
  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value+' && Valid = ' + abstractControl.valid);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          //  console.log(messages)
          for (const errorKey in abstractControl.errors) {
            //  console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  clickOnManyDay(budgetDetail, index) {
    console.log('budgetdetails', budgetDetail);
    console.log('input value ', budgetDetail.value.budgetedDays);
    console.log('mandayscount in assignment', this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays);
    console.log('this.budgetForm.value.assignment', this.budgetForm.value.assignment);
    this.isExistBudgetCheck = true;
    this.setAssignmentValue = this.budgetForm.value.assignment;
    if ((budgetDetail.value.budgetedDays) % 0.5 == 0) {
    } else {
      this.commonMessageService.swalAlertWithoutIcon('','Please enter valid man days.');
      this.budgetForm.controls.budgetDetails.controls[index].patchValue({
        budgetedDays: 0,
      });
    }

    var manDaysCount;
    if (budgetDetail.value.budgetedDays > this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays) {
      manDaysCount = (budgetDetail.value.budgetedDays - this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays);
      console.log('mandays count', manDaysCount);

      var fyId = this.budgetForm.value.financialYear.id;
      var userId = budgetDetail.value.user.id;

      this.masterDataService
        .getManDaysInBudgetClientDetails(fyId, userId)
        .subscribe((res) => {
          console.log('response details', res);
          if (budgetDetail.value.role.name != 'Article') {
            console.log('Article name value', budgetDetail.value.role.name);
            if (res != null) {
              var totalManDaysCount = res.budgetedDays + manDaysCount;
              console.log('totalmandays count', totalManDaysCount);
              if (totalManDaysCount > 5000) {
                console.log('inside if condition');
                 this.commonMessageService.swalAlertWithoutIcon('','Man Days count is higher that 5000 So please make it less');
                this.budgetForm.controls.budgetDetails.controls[index].patchValue({
                  budgetedDays: this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays,
                });
              }
            } else {
              if (manDaysCount > 5000) {
                console.log('inside else if condition');
                 this.commonMessageService.swalAlertWithoutIcon('','Man Days count is higher that 5000 So please make it less');
                this.budgetForm.controls.budgetDetails.controls[index].patchValue({
                  budgetedDays: this.onAssignmentSelectBudgetDays.budgetDetails[index].budgetedDays,
                });
              }
            }
          } else {
            console.log('artile here else condition', budgetDetail.value.budgetedDays);
            this.budgetForm.controls.budgetDetails.controls[index].patchValue({
              budgetedDays: budgetDetail.value.budgetedDays,
            });
          }
        });
    }
  }
  onCountClick() {
    this.isExistBudgetCheck = true;
    this.setAssignmentValue = this.budgetForm.value.assignment;
  }

  onAssignmentFeesChange() {
    this.setAssignmentValue = this.budgetForm.value.assignment;
  }
}
